import { BoltIcon } from "@heroicons/react/24/outline"
import { Info } from "../cards/Info"
import { Container } from "../shared/Container"
import { Paragraph } from "../shared/Paragraph"
import { Title } from "../shared/Title"
import lightning from "/assets/lightning.jpg"

export const AboutUs = () => {
  return (
    <section id="about-us">
      {" "}
      <Container className="flex flex-col items-center gap-10 md:flex-row lg:gap-12">
        <div className="w-full md:w-5/12 lg:w-1/2">
          <div className="relative h-80 w-full sm:h-96">
            <img
              src={lightning}
              className="relative z-10 h-full w-full rounded-3xl object-cover shadow-lg"
              alt="About Our Mission"
            />
          </div>
        </div>

        <div className="flex w-full flex-col md:w-7/12 lg:w-1/2">
          <Title> About Us</Title>
          <Paragraph>
            We are on a mission to speed up follow-up emails. Quit jumping between screens and get everything
            at your fingertips.
          </Paragraph>

          <div className="grid max-w-3xl grid-cols-1 gap-4 pt-8 sm:grid-cols-2">
            <Info title="Mission" description="Data and email in one place">
              <BoltIcon className="h-5 w-5" aria-hidden="true" />
            </Info>
            <Info title="Vision" description="Save time, so you can focus on your patients">
              <BoltIcon className="h-5 w-5" aria-hidden="true" />
            </Info>
          </div>
        </div>
      </Container>
    </section>
  )
}
